const activities = {
  createAnActivity: 'Create an Activity',
  noActivitiesToDisplay: 'No activities to display',
  noActivityToDisplay: 'No activity to display',
  xSelectedActivities_one: '{{count}} selected activity',
  xSelectedActivities_other: '{{count}} selected activities',
};

export default activities;
